// extracted by mini-css-extract-plugin
module.exports = {"containerOverOsano":"BaseUpsellModal_containerOverOsano__VsEc6","taller":"BaseUpsellModal_taller__Enyc8"};